import {Box, Divider, Typography} from "@mui/material";
import {grey, red} from "@mui/material/colors";

const Guideline = () => {
    return(
        <Box sx = {{height: "85%", backgroundColor: "whitesmoke", border: "1px solid whitesmoke" ,borderRadius: 5,p: 2, }}>
            <Box sx={ {mt:2}}>
                <Typography  variant="subtitle1" > Guideline </Typography>
                <Divider variant="middle" sx = {{borderColor:grey[400]}}/>
                <Box sx = {{mt: 3, textAlign: "center"}}>
                    <img
                        src={require("../../assets/DentImg/dent.png")}
                        alt="SCA"
                        style={{width: "100%"}}
                    />
                </Box>
                <Typography align="justify" sx = {{typography: {xl: 'subtitle2', lg: "subtitle2", md: "caption", sm: "caption", xs:"caption" },mt: 3,pb:1, pl: 3, pr: 3, fontStyle: 'italic' }}  >
                    "The critical region is defined when the edge of the dent is within the location of  ½ inch and ¾  inch dimensions from the underlying stiffener fastener, as defined in the figures. Analysis can be continued provided that there is no deformation of the underlying structure, minor deformation of the free flange maybe acceptable."
                </Typography>
            </Box>
        </Box>
    );
}
export default Guideline;